import * as React from "react";

import {Legend} from "../../../../core/components/legend/legend";
import {Item} from "semantic-ui-react";
import {SidebarControlsConfiguration} from "../../../../config/sidebar-configuration";
import {MapViewerStore} from "../../../../stores/map-viewer-store-mobx";
import {withStore} from "../../../../core/stores/abstract-app-store";


export interface AsideProps {
    view: __esri.MapView | __esri.SceneView | undefined;
    store?: MapViewerStore; // this is injected by withStore
}

class AsideBase extends React.Component<AsideProps, any> {
    constructor(props: AsideProps) {
        super(props);
    }
    render(): React.ReactElement | null {
        const { store } = this.props;
        if(!store){
            return null;
        }
        const { appStore, mapStore, mapViewerConfig} = store;
        const {asideContent} = appStore;
        const legendConfig = mapViewerConfig.legend;
        const items: React.ReactElement[] = [];
        if (asideContent) {
            items.push(<Item key={"content"}>{asideContent}</Item>);
        }
        if (typeof legendConfig.esriConfig !== "undefined" && store.oStore.showMap){
            items.push(<Item key={"legend"}>
                <div>
                    <h2>{legendConfig.title}</h2>
                    <Legend
                        mapStore={mapStore}
                        uiStore={store.uiStore}
                        view={mapStore.view}
                        config={legendConfig.esriConfig}
                        controlsConfig={mapViewerConfig as SidebarControlsConfiguration}  />
                </div>
            </Item>);
        }
        if (items.length === 0) {
            return <aside id="rightContent" className="layout__aside" />;
        } else {
            return (
                <aside id="rightContent" className="layout__aside">
                    <Item.Group divided>
                        {items}
                    </Item.Group>
                </aside>
            );
        }
    }
}

export const Aside = withStore(AsideBase);
